module.exports = __webpack_public_path__ + "static/Monda-Regular-9fd609ab23682616d773ad7496334c86.woff";